import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react';
import { useStore } from '../../../stores/Store';
import './style.scss';
import { BreifCardV2, OutlinedButton } from '../../../components';
import { processProjectsData,processProfessionalsData,processProjectsAndBriefs } from '../../../utils/sharedFunctions';
import PreviewBrief from '../BriefPreview';
import CreateBrief from "../Briefs/CreateBrief";
const AddIcon = `${process.env.REACT_APP_CDN_URL}/globalAssets/AddIcon.svg`;
const Credipple = `${process.env.REACT_APP_CDN_URL}/globalAssets/CredippleWhiteLogo.svg`;
const SearchIcon = `${process.env.REACT_APP_CDN_URL}/globalAssets/SearchIcon.svg`;
const UserIcon = `${process.env.REACT_APP_CDN_URL}/globalAssets/people.png`;
var mobile = require('is-mobile');

const Briefs = observer(() => {
    const store = useStore();
    const [, updateState] = useState();
    const forceUpdate = React.useCallback(() => updateState({}), []);
    const [IsViewClicked, setIsViewClicked] = useState(false);
    const [SelectedBrief, setSelectedBrief] = useState({});
    const [Briefs, setBriefs] = useState([]);
    const [Create, setCreate] = useState(false);
    const [Clients, setClients] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [Leads, setLeads] = useState([]);
    const [ProjectMenu, setProjectMenu] = useState(false);
    const [Professionals, setProfessionals] = useState([]);
    const [AllUsers, setAllUsers] = useState([]);
    useEffect(() => {
        getBriefs();
    }, []);

    const fetchProjectData = async () => {
        try {
            return await Promise.all([
                store.getBriefs(),
                store.getProjectPlans(),
                store.getProjects(),
                store.getEvaluation(),
                store.getVouchers(),
                store.getQuote(),
                store.getUsers()
            ]);
        } catch (e) {
            console.error('Error fetching project data:', e);
            return [[], [], [], [], [], [], []];
        }
    };

    const fetchProsAndLeads = async (users) => {
        const validUsers = Array.isArray(users) ? users.filter(user => user.roles?.length > 0) : [];
        return {
            Leads: validUsers.filter(user => user.roles[0] === 1987),
            Pros: validUsers.filter(user => user.roles[0] === 1988),
            Clients: validUsers.filter(user => user.roles[0] === 1989)
        };
    };

    const getBriefs = async () => {
        store.setLoading(true);
        try {
            const [confirmedProjects, projPlans, projects, evaluation, vouchers, quotes, users] = await fetchProjectData();
            const prosAndLeads = await fetchProsAndLeads(users);

            const processedBriefs = processProjectsData(
                confirmedProjects || [],
                projPlans || [],
                projects || [],
                evaluation || [],
                vouchers || [],
                quotes || [],
                prosAndLeads
            );

            const allUsers = [...prosAndLeads.Leads, ...prosAndLeads.Pros, ...prosAndLeads.Clients];
            const validProjects = processProjectsAndBriefs(projects, processedBriefs, prosAndLeads.Leads, evaluation, prosAndLeads.Clients, projPlans);
            const professionals = processProfessionalsData(prosAndLeads.Pros, validProjects.processedProjects, processedBriefs);

            setAllUsers(allUsers ?? []);
            setLeads(prosAndLeads.Leads ?? []);
            setClients(prosAndLeads.Clients ?? []);
            setProfessionals(professionals ?? []);
            setBriefs(processedBriefs ?? []);
            forceUpdate();
        } catch (error) {
            console.error('Error fetching briefs:', error);
        } finally {
            store.setLoading(false);
        }
    };

    const openAddProjectMenu = () => {
        setProjectMenu(true);
        forceUpdate();
    };
    const closeAddProjectMenu = () => {
        setProjectMenu(false);
        forceUpdate();
    };
    const backClicked = (e, isEdited) => {
        if (isEdited) {
            getBriefs();
        }
        setIsViewClicked(false);
        setSelectedBrief({});
        forceUpdate();
    };
    const handleSelectedBrief = async (id) => {
        let projects = Briefs;
        let selectedProject = projects.find(project => project._id === id);
        setSelectedBrief(selectedProject);
        setIsViewClicked(true);
        forceUpdate();
    };
    const handleCreate = () => {
        setCreate(true);
    };
    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
        forceUpdate();
    };
    const filteredBriefs = Briefs.filter(brief => {
        const searchValue = String(searchTerm).toLowerCase();
        if (brief.briefTitle !== null) {
            return (brief.briefTitle.toLowerCase().includes(searchValue));
        }
    });

    if (mobile()) {
        return (
            <div>

            </div>
        );

    } else {
        return (
            <div className='projectsPage'>
                <div className='projectsPageHeader' style={{ height: `${Object.keys(SelectedBrief).length > 0 ? '13%' : '26%'}` }}>
                    <div className='head_content'>
                        <div className='addbrief'>
                            <p className='brief_text' >Briefs</p>
                            {Object.keys(SelectedBrief).length === 0 ?
                                <div className='projectListSection'>
                                    <p style={{ color: 'white', margin: '0%' }}>Brief List</p>
                                    {store.user.permissions.includes("Brief_Create") ? (<div className='addNewProjectMenu' onMouseEnter={openAddProjectMenu} onMouseLeave={closeAddProjectMenu}> ...
                                        {(ProjectMenu) ?
                                            <div className='userMenuOpen'>
                                                <div className='AddUserConatiner'>
                                                    <img src={AddIcon} alt='Add User' onClick={handleCreate} />
                                                    <p style={{ cursor: 'pointer' }} onClick={handleCreate}>Add Brief</p>
                                                </div>
                                                <hr />
                                            </div> : null}
                                    </div>) : null}
                                </div>
                                : null
                            }
                        </div>
                        {!IsViewClicked &&
                            <div className='numofItems'>
                                <p className='spancular'>{filteredBriefs.length}</p>
                            </div>}
                        <div className='search_filter'>
                            <img className='logo' src={Credipple} alt='Credipple Logo' />
                            {Object.keys(SelectedBrief).length === 0 ?
                                <div className='search-bar-section' style={{ height: '20%' }}>
                                    <img src={SearchIcon} alt='Search Icon' />
                                    <input style={{ color: '#6D4194' }} placeholder='Search' onChange={handleSearchChange}></input>
                                </div>
                                : null
                            }
                        </div>
                    </div>
                </div>

                {!IsViewClicked ?
                    <div className='projectsPageBody'>
                        <div className='main'>
                            <span className='topbar_background' />
                            <div className='brief_cards_cover' >
                                {filteredBriefs.map((item, index) => {
                                    return (
                                        <div className='projectCard' key={index} onClick={() => handleSelectedBrief(item._id)}>
                                            <div className='viewprojectHeader'>
                                                <p>{item.briefTitle || ''}</p>
                                            </div>
                                            <div className='viewProjectDetails' >
                                                <div className='profileANdUserDetails'>
                                                    <div className='userProfile'>
                                                        <img src={UserIcon} alt='User Icon' style={{ width: '100%', height: '100%' }} />
                                                    </div>
                                                    <div className='userProfile-Details'>
                                                        <p className='header' style={{ fontWeight: '700' }}>{`${item.client?.firstName ?? ''} ${item.client?.lastName ?? item.client?.companyName ?? 'Not Assigned'}`.trim()}</p>
                                                        <p className='value'>
                                                            {item.client?.email ? item.client.email.substring(0, 20) : item.client?.website ? item.client.website.substring(0, 20) : 'Not Assigned'}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className='fulfillmentLeadDetails'>
                                                    <p className='header' style={{ fontWeight: '700', margin: '0px' }}>Fulfillment Lead</p>
                                                    <p className='value' style={{ margin: '0px' }}>{`${item.talentPartner?.firstName ?? 'Not Assigned'} ${item.talentPartner?.lastName ?? ''}`.trim()}</p>
                                                </div>
                                            </div>
                                            <div className='viewDetailsContainer'>
                                                <OutlinedButton className='detailsBtn'><p style={{ margin: '0' }}>View Details</p></OutlinedButton>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>

                    </div>
                    : null
                }

                {Create ?
                    <CreateBrief onClose={e => { setCreate(false); }} SelectedBrief={SelectedBrief} type={'Brief'} briefs={Briefs} clients={Clients} leads={Leads} isCreated={e => { if (e) { getBriefs() }; }} /> : null
                }

                {Object.keys(SelectedBrief).length === 0 ? null :
                    <div className='previewparent'>
                        <PreviewBrief project={SelectedBrief} AllUsers={AllUsers} navigateMainToPage={(e, isEdited) => backClicked(e, isEdited)} professionals={Professionals} leads={Leads} />
                    </div>
                }
            </div>
        );
    };
});

export default Briefs;